import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { activityChipColor, chipTextColor } from '../util/CalendarLogic.jsx';
import { calendarChipTooltipLines } from '../util/calendarChipTooltip.js';

const CHIP_POPPER = {
	strategy: 'fixed',
	modifiers: [
		{
			name: 'preventOverflow',
			options: { boundary: 'viewport', padding: 8, altAxis: true }
		},
		{
			name: 'flip',
			options: { padding: 8 }
		}
	]
};

const CalendarChip = ({
	activity,
	dayKey,
	datasetId,
	colorBy,
	codeTypeId,
	datasetInfo,
	onActivate
}) => {
	const color = activityChipColor(activity, colorBy, codeTypeId, datasetInfo);
	const textColor = chipTextColor(color);
	const lines = calendarChipTooltipLines(activity);
	const to = datasetId
		? `/app/dataset/${datasetId}/activity/${activity.activityId}/`
		: '#';
	const tipId = `calendar-chip-${dayKey}-${activity.activityId}`;
	return (
		<OverlayTrigger
			placement="top"
			flip
			delay={{ show: 250, hide: 80 }}
			popperConfig={CHIP_POPPER}
			overlay={(
				<Tooltip id={tipId} className="calendarChipTooltip">
					{lines.map((line, index) => (
						<div
							key={`${tipId}-${index}`}
							className={index === 0 ? 'calendarChipTooltipName' : 'calendarChipTooltipMeta'}>
							{line}
						</div>
					))}
				</Tooltip>
			)}>
			<Link
				className="calendarChip"
				style={{ backgroundColor: color, color: textColor }}
				to={to}
				aria-label={lines.join(', ')}
				onClick={onActivate}>
				{activity.name}
			</Link>
		</OverlayTrigger>
	);
};

CalendarChip.propTypes = {
	activity: PropTypes.object.isRequired,
	dayKey: PropTypes.string.isRequired,
	datasetId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	colorBy: PropTypes.string,
	codeTypeId: PropTypes.string,
	datasetInfo: PropTypes.object,
	onActivate: PropTypes.func
};

export default CalendarChip;
